<template>
  <div class="price-calendar" v-loading="loading">
    <div class="hotels pc" v-if="calendarHotel.length">
      <div class="hotel"
           :class="{active:hotel.code===hotel_code}"
           v-for="(hotel,index) of calendarHotel"
           :key="index"
           @click="hotelChange(hotel.code)">
        <!--        <img :class="hotel.code" :src="require('@/assets/images/hotel/'+ hotelImg(hotel.code))" :alt="hotel.name">-->
        <img :class="hotel.code" :src="hotel.icon" :alt="hotel.name" style="cursor:Default">
      </div>
    </div>

    <el-dropdown @command="hotelChange" class="hotel-switch mob" trigger="click" placement="bottom" v-if="curHotel">
      <span class="el-dropdown-link">
        {{ curHotel.name }}<i class="el-icon-caret-bottom el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown" class="mob-hotel-switch">
        <el-dropdown-item
          :command="hotel.code"
          v-for="(hotel,index) of hotels"
          :class="{active:hotel.code===hotel_code}"
          :key="index">
          {{ hotel.name }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <div class="position-box">
      <el-calendar ref="calendar" :first-day-of-week="0" :class="[status,{hideTr1}]" v-model="activeDay">
        <template
          v-slot:dateCell="{data}">
          <div @click.stop="saveDay(data.day)"
               :class="{active:isActive(data.day),
             disable:isDisabled(data.day),
             'unavailable':available(data.day),
             'check-in':new Date(data.day).getTime()===startDay.getTime(),
             'check-out':new Date(data.day).getTime()===endDay.getTime()}"
               :day="new Date(data.day).getTime()">
            <div class="box">
              <span class="day">
                {{ data.day.split('-')[2] }}
              </span>
              <p class="in" v-if="new Date(data.day).getTime()===startDay.getTime()">
                <span class="pc">{{ $t('Check-in') }}!</span><span class="mob">{{ $t('Check in') }}</span>
              </p>
              <p class="out" v-if="new Date(data.day).getTime()===endDay.getTime()">
                <span class="pc">{{ $t('Checkout') }}!</span><span class="mob">{{ $t('Check out') }}</span>
              </p>
              <p class="currency mob">{{ $t(currency) }}</p>
              <!--          <p class="price" v-text="price_table[data.day]?price_table[data.day].price:''"/>-->
              <p class="price pc">{{ price_table[data.day] | calendarPrice(that) }}</p>
              <p class="price mob">{{ price_table[data.day] | calendarPrice(that,false) }}</p>
              <p class="text pc" v-if="price_table[data.day]">
                {{ $t('{s} per night',{s:$t(currency)}) }}
              </p>
            </div>
          </div>

        </template>
      </el-calendar>

      <div class="en-date" v-if="enDateFormat">
        {{ enDateFormat }}
      </div>
    </div>

    <p class="day-long"><i class="el-icon-warning-outline"/>
      <template v-if="day0&&day1">{{ $t("You have selected %{s} nights", {s: dayLong ? dayLong : 0}) }}</template>
      <template v-if="!day0">{{ $t("Please click on your arrival date") }}</template>
      <template v-if="day0&&!day1">{{ $t("Please click on your departure date") }}</template>
    </p>

    <div class="calendar-action">
      <el-button class="action-rest" @click="reset" v-if="day0">{{ $t('RESET') }}</el-button>
      <el-button
        class="action-submit"
        :class="disableSubmit?'btn-forbid':''"
        type="primary"
        @click="submit"
        v-if="day0&&day1"
        :disabled="disableSubmit"
      >{{
          $t('SUBMIT')
        }}
      </el-button>
    </div>
  </div>
</template>

<script>

import util from "../util";
import {mapState} from 'vuex'

const CancelToken = window.axios.CancelToken;


export default {
  name: 'PriceCalendar',
  props: {
    initDay: {
      type: Object
    },
    hotel_code: {
      type: String,
    }
  },
  data() {
    return {
      price_table: '',
      day0: '',
      day1: '',
      loading: false,
      cancel: null,
      monthFlag: "",
      enDateFormat: "",
      hideTr1: false,
      curMonthNum: '',
      activeDay: '',
    }
  },
  methods: {
    getPrice(month, code) {
      if (typeof this.cancel === 'function') {
        this.cancel();
      }
      this.loading = true
      this.axios.get(`/api/group/info/calendar?month=${month}&hotel_code=${code}`, {
        cancelToken: new CancelToken((c) => {
          this.cancel = c;
        })
      }).then(
        (res) => {
          if (res.code === 200) {
            this.price_table = res.data;
            var flag = true
            if(!this.price_table[this.initDay.day0]) {
              Object.keys(this.price_table).map((key, index) => {
                if(flag == true) {
                  if(this.price_table[key].price != -1) {
                    this.initDay.day0 = key
                    this.initDay.day1 = Object.keys(this.price_table)[index + 1]
                    flag = false
                  }
                }
              })
            }
            this.$emit('hotel-change-init', {startDay: new Date(this.initDay.day0), endDay: new Date(this.initDay.day1)})
            this.monthFlag = res.monthFlag;
          }
        }
      ).finally(() => {
        this.loading = false
      })
    },
    init() {
      //parent use this fn
      this.day0 = this.initDay.day0
      this.day1 = this.initDay.day1
    },
    saveDay1(day) {
      if (this.isDisabled(day)) {
        return
      }
      if (this.day0 && this.day1 || util.dateArr(day) <= util.dateArr(this.day0)) {
        this.reset()
      }
      if (!this.day0) {
        this.day0 = day
      } else {
        this.day1 = day
      }
    },
    saveDay(day) {
      const vipRule = this.day0 && !this.day1 && util.dateArr(day) > util.dateArr(this.day0)
      if (this.isDisabled(day) && !vipRule) {
        return
      }
      //选择新的日期
      const reset1 = this.day0 && this.day1
      //第二次日期小于第一次日期
      const reset2 = util.dateArr(day) <= util.dateArr(this.day0)
      if (reset1 || reset2) {
        this.reset()
      }
      if (!this.day0) {
        this.day0 = day
      } else {
        const dayArr = Object.keys(this.price_table).sort()
        const selectDays = dayArr.slice(dayArr.indexOf(this.day0), dayArr.indexOf(day))
        const unavailable = selectDays.find((x) =>
          this.price_table[x].price === -1
        )
        //日期区间中有不可选的日期
        if (unavailable) {
          this.day0 = day
        } else {
          this.day1 = day
        }
      }
    },


    isActive(day) {
      if (this.day0 && this.day1) {
        let arr = [this.day0, this.day1, day].map(x => x.replace('-', '')).sort()
        return arr[1] === day.replace('-', '')
      }
      return false
    },
    isDisabled(day) {
      return (new Date() - new Date(day) > util.DAY * (this.curHotel?.can_booking_yesterday + 1)) || this.available(day)
    },
    reset() {
      this.day0 = ''
      this.day1 = ''
    },
    hotelChange(hotelCode) {
      if (hotelCode === this.hotel_code) {
        return
      }
      this.$emit('hotel-change', hotelCode)
    },
    submit() {
      this.$emit('calendar-submit', {startDay: this.startDay, endDay: this.endDay})
      this.$store.commit('stateChange', {k: 'onceSubmit', v: true})
    },
    hotelImg(hotelCode) {
      let img
      switch (hotelCode) {
        case 'KL':
          img = 'tkl-logo01.png';
          break;
        case 'FSDH':
          img = 'pvm-logo01.png';
          break;
        case 'opera1':
          img = 'glp-logo01.png';
      }
      return img
    },
    available(day) {
      return this.price_table[day] ? this.price_table[day].price == -1 : true
    },
  },
  filters: {
    calendarPrice(obj, that, showIcon = false) {
      if (!obj) {
        return ''
      }
      if (+obj.price === 0) {
        return that.$t('Free')
      } else if (obj.price === -1) {
        return that.$t('Not Available')
      } else {
        return (showIcon ? that.currencyIcon : '') + obj.price
      }
    }
  },
  computed: {
    ...mapState(
      ['hotels', 'currency']
    ),
    currencyIcon() {
      return this.$store.getters.currencyIcon
    },
    startDay() {
      return new Date(this.day0) > new Date(this.day1) ? new Date(this.day1) : new Date(this.day0)
    },
    endDay() {
      let day
      try {
        day = (new Date(this.day0) > new Date(this.day1) ? new Date(this.day0) : new Date(this.day1))
      } catch (e) {
        day = ''
      }
      return day
    },
    //定几天房
    dayLong() {
      return (this.endDay - this.startDay) / 1000 / 60 / 60 / 24
    },
    curMonth() {
      return this.$refs.calendar?.curMonthDatePrefix
    },
    nextMonth() {
      return this.$refs.calendar?.nextMonthDatePrefix
    },
    curHotel() {
      return this.hotels.find(hotel => hotel.code === this.hotel_code);
    },
    enDate() {
      let arr = this.$refs.calendar?.i18nDate.split(' ')
      if (this.status.lang_en) {
        return arr[arr.length - 1] + ' ' + arr[0]
      } else {
        return arr[arr.length - 2] + arr[arr.length - 1] + ' ' + arr[0]
      }
    },
    status() {
      //库存禁止翻页逻辑，已弃用
      let no_next;
      let no_prev;
      if (this.monthFlag) {
        no_next = this.monthFlag[this.$refs.calendar.nextMonthDatePrefix]
        no_prev = Object.keys(this.monthFlag).length < 3 || this.monthFlag[this.$refs.calendar.prevMonthDatePrefix]
      }
      //月份禁止翻页逻辑
      let no_up;
      let no_down;

      if (this.numMonth < 1) {
        no_up = true
      }
      if(this.price_table) {
        const lastDayTime = new Date(Object.keys(this.price_table)[Object.keys(this.price_table).length - 1]).getTime()
        const nextMonthTime = new Date(this.nextMonth).getTime()
        if(lastDayTime <= nextMonthTime) {
          no_down = true
        }
      }



      return {
        no_next,
        no_prev,
        no_up,
        no_down,
        lang_en: this.$i18n.locale === 'en'
      }
    },
    numMonth() {
      const curMonth = this.curMonthNum.split('-')
      const nowMonth = [new Date().getFullYear(), new Date().getMonth() + 1]
      return curMonth[0] * 12 + parseInt(curMonth[1]) - (nowMonth[0] * 12 + nowMonth[1])
    },
    calendarHotel() {
      let arr = []
      if (this.hotels.length) {
        if (this.hotels.length == 3) {
          arr = [this.hotels[1], this.hotels[0], this.hotels[2]]
        } else {
          arr = this.hotels
        }
      }
      return arr
    },
    hideTr() {
      return this.$refs.calendar?.$children[1].rows[0][6].type === 'prev'
    },
    disableSubmit() {
      // let type = false
      const max_err = this.curHotel.max_booking_days < this.dayLong
      const dayArr = Object.keys(this.price_table).sort()
      const selectDays = dayArr.slice(dayArr.indexOf(this.day0), dayArr.indexOf(this.day1))
      const unavailable = selectDays.find((x) =>
        this.price_table[x].price === -1
      )
      return max_err || !!unavailable
    },
    notOpening() {
      let openDay = this.curHotel.opening_date
      if (new Date() > new Date(util.dateArr(openDay))) {
        openDay = false
      }
      return openDay
    }
  },
  mounted() {
    this.$store.commit('stateChange', {k: 'onceSubmit', v: false})
    this.$watch('curMonth', function (newVal) {
      // this.getPrice(newVal, this.hotel_code)
      this.curMonthNum = newVal
    })
    this.curMonthNum = this.curMonth
    this.enDateFormat = this.enDate
    this.hideTr1 = this.hideTr
    this.$watch('enDate', function (newVal) {
      this.enDateFormat = newVal
      this.hideTr1 = this.hideTr
    })
    if (this.$route.name === 'Home') {
      this.$watch('hotels', function () {
        this.hotelChange(this.hotels[0].code)
      })
    }

    this.$watch('hotel_code', function (hotel_code) {
      this.activeDay = this.initDay.day0
      this.getPrice(this.curMonth, hotel_code)
    })
  },
  created() {
    this.init()
  }
}
</script>
